import { render, staticRenderFns } from "./receive-packet.vue?vue&type=template&id=fbda291a&scoped=true&lang=pug&"
import script from "./receive-packet.vue?vue&type=script&lang=js&"
export * from "./receive-packet.vue?vue&type=script&lang=js&"
import style0 from "./receive-packet.vue?vue&type=style&index=0&id=fbda291a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbda291a",
  null
  
)

export default component.exports